import { isNumber } from '../assertion'

export const ariaAttr = condition => (condition ? true : null)

export const dataAttr = condition => (condition ? '' : null)

export function canUseDOM() {
  return !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  )
}

export const isBrowser = canUseDOM()

export function isElement(el) {
  return (
    el != null &&
    typeof el == 'object' &&
    'nodeType' in el &&
    el.nodeType === Node.ELEMENT_NODE
  )
}

export function isHTMLElement(el) {
  if (!isElement(el)) {
    return false
  }

  const win = el.ownerDocument.defaultView ?? window
  return el instanceof win.HTMLElement
}

export function getOwnerWindow(node) {
  return isElement(node)
    ? getOwnerDocument(node)?.defaultView ?? window
    : window
}

export function getOwnerDocument(node) {
  return isElement(node) ? node.ownerDocument ?? document : document
}

export function getEventWindow(event) {
  return event.view ?? window
}

export function getActiveElement(node) {
  const doc = getOwnerDocument(node)
  return doc?.activeElement
}

export function getRelatedTarget(event) {
  const target = event.target ?? event.currentTarget
  const activeElement = getActiveElement(target)
  return event.relatedTarget ?? activeElement
}

export function contains(parent, child) {
  if (!parent) return false

  return parent === child || parent.contains(child)
}

export function addDomEvent(target, eventName, handler, options) {
  target.addEventListener(eventName, handler, options)

  return () => {
    target.removeEventListener(eventName, handler, options)
  }
}

export function mergeClassnames(...classnames) {
  return classnames.filter(Boolean).join(' ')
}

export function getStringWidth(
  value = '',
  {
    fontSize = 15,
    lineHeight = null,
    letterSpacing = null,
    padding = 0,
    ...rest
  }
) {
  const div = document.createElement('div')
  div.innerText = value

  const _fontSize = isNumber(fontSize) ? `${fontSize}px` : fontSize
  const _lineHeight = isNumber(lineHeight) ? `${lineHeight}px` : lineHeight
  const _letterSpacing = isNumber(letterSpacing)
    ? `${letterSpacing}px`
    : letterSpacing
  const _padding = isNumber(padding) ? `0 ${padding}px` : `0 ${padding}`

  Object.assign(div.style, {
    fontSize: _fontSize,
    lineHeight: _lineHeight,
    letterSpacing: _letterSpacing,
    padding: _padding,
    width: 'auto',
    display: 'inline-block',
    visibility: 'hidden',
    position: 'fixed',
    overflow: 'auto',
    boxSizing: 'border-box',
    ...rest
  })

  document.body.append(div)
  const width = div.clientWidth
  div.remove()

  return width
}
